import Base from "components/Base";
import Estagio from "model/producao/Estagio";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ApontamentoOpService from "service/producao/ApontamentoService";

type Props = {

}

const apontamentoOpService = new ApontamentoOpService();

function EscolherEstagio(props: Props) {

    const navigate = useNavigate();

    const [estagios, setEstagios] = useState<Estagio[]>([]);
    const [estagioSelecionado, setEstagioSelecionado] = useState<Estagio | null>(null);
    const [dialogVisible, setDialogVisible] = useState<boolean>(true);

    useEffect(() => {
        apontamentoOpService.estagios().then(data => {
            if (data.length === 1) {
                irParaListagem(data[0]);
            } else {
                setEstagios(data);
            }
        }).catch(error => {
            console.error(error);
        });
    }, []);

    const irParaListagem = (estagio: Estagio) => {
        navigate(`/apontamentoOp/listagem/${estagio.id}`);
    }

    return (

        <Base tituloPagina={"Escolher estágio"}>
            <Dialog visible={dialogVisible} style={{ width: '25vw' }} onHide={() => { setDialogVisible(false) }} header="Escolher Estágio" modal
                footer={<Button label="Selecionar" disabled={!estagioSelecionado} onClick={() => {
                    setDialogVisible(false);
                    if (estagioSelecionado) {
                        irParaListagem(estagioSelecionado)
                    }
                }} />} >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Dropdown optionLabel="nome" placeholder="Selecione um estágio" options={estagios}
                        value={estagioSelecionado} onChange={(e) => { setEstagioSelecionado(e.value) }} />


                </div>

            </Dialog>

            <div className="container">



            </div>
        </Base>
    );

}

export default EscolherEstagio;